module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-800-heavy-eb76033213ef9129c003e8abbf614ca5.woff2";